export const supportedUnitTypeIds = [28, 30, 53, 61, 62, 60, 63];
